const ORGANIZATIONS = {
    DILAWRI: 481,
};

export default ORGANIZATIONS;
